import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 查询费用大类列表
export function queryHousekeepingFeeType(params) {
  params.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeType/queryHousekeepingFeeType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加费用大类
export function saveHousekeepingFeeType(data) {
  data.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeType/saveHousekeepingFeeType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改费用大类
export function updateHousekeepingFeeType(data) {
  data.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeType/updateHousekeepingFeeType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除费用大类
export function deleteHousekeepingFeeType(data) {
  data.shopId = getShopId()
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeType/deleteHousekeepingFeeType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}